import client from './api';

// Kampanyanın ham HTML açıklaması (`GET /bonuses/{id}/description-html`).
// Liste ucu şablonu taşımaz; kart ve detay penceresi onu buradan ister.
// Aynı sayfada kart ile pencere aynı şablonu iki kez indirmesin diye istek
// kampanya başına bir kez yapılır; başarısız istek önbellekten düşer ve bir
// sonraki çağrıda yeniden denenir.
const cache = new Map();

export const fetchBonusDescriptionHtml = (id) => {
  if (!id) return Promise.resolve('');
  if (!cache.has(id)) {
    const request = client.get(`/bonuses/${id}/description-html`)
      .then(({ data }) => data?.html || '')
      .catch((error) => {
        cache.delete(id);
        throw error;
      });
    cache.set(id, request);
  }
  return cache.get(id);
};

export const clearBonusDescriptionHtmlCache = () => cache.clear();
